import {
    Button ,Stack,
    Modal,
    ModalBody,
    ModalContent, ModalFooter,
    ModalHeader,
    ModalOverlay,
    SimpleGrid, Text,
} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {
    exportHilanPayrollFileFromTransfers,
    exportMalamPayrollFileFromTransfers,
    generateShiklulitPayrollFileFromTransfers
} from "../../../../functions/generatePayrollFile";
import {
    exportElectraTransfersFeesFile,
    exportHalperinTransfersFeesFile,
    exportHomeCenterTransfersFeesFile,
    exportPazDetailedReport,
    exportPazSummaryReport
} from "../../../../functions/generateReports";
import ReportsApi from "../../../../api/reports";


import { useToast } from '@chakra-ui/react';
import {DocumentTypesEnum} from "../../../admin/reports/components/DocumentTypeEnum";
import MockApi, {getCurrentMonthAndYear} from "../../../../api/mockApi";
import {downloadPdf} from "../../../../functions/file.utils";

export default function ReportDetailsModal(props) {

    let { isOpen, onClose, report, date, data, tempReport = false } = props;
    const [totalTransfers, setTotalTransfers] = React.useState(0)
    const [totalEmployeesTransferFees, setTotalEmployeesTransferFees] = React.useState(0)
    const [totalCompanyServiceSubscriptionFee, setTotalCompanyServiceSubscriptionFee] = React.useState(0)
    const [totalSettlementAmount, setTotalSettlementAmount] = React.useState(0)
    const [reportCompanyId, setReportCompanyId] = React.useState("")
    const [reportStatus, setReportStatus] = React.useState("")
    const [loading, setLoading] = useState(false);
    const [selectedDocumentType, setSelectedDocumentType] = React.useState(null);
    const [deductTransferFeesFromSubscription, setDeductTransferFeesFromSubscription] = React.useState(false);

    const toast = useToast();

    useEffect(() => {
        if(isOpen && report) {
            setTotalTransfers(report.transfersAmount)
            setTotalEmployeesTransferFees(report.usersTransfersFee)
            setTotalCompanyServiceSubscriptionFee(report.totalCompanyServiceSubscriptionFee)
            setTotalSettlementAmount(report.settlementTotalAmount)
            setReportCompanyId(report.companyId)
            setDeductTransferFeesFromSubscription(
                !!report.deductTransferFeesFromSubscription
            );
        }
        if(!isOpen) {
            setTotalTransfers(0)
            setTotalEmployeesTransferFees(0)
            setTotalCompanyServiceSubscriptionFee(0)
            setTotalSettlementAmount(0)
            setReportCompanyId("")
            setDeductTransferFeesFromSubscription(false);
        }
    }, [isOpen]);

    const handlePayrollExportClick = () => {
        ReportsApi.getTransfersListWithFee(date, reportCompanyId)
            .then(res => {
                const transfersData = res.data;
                generateShiklulitPayrollFileFromTransfers(date, transfersData);
            })
            .catch(e => {
                toast({
                    title: `שגיאה בהורדת הדו"ח`,
                    position: 'top',
                    status: 'error',
                    isClosable: false,
                });
            });
    }

    const handleMalamExportClick = () => {
        ReportsApi.getTransfersListWithFee(date, reportCompanyId)
            .then(res => {
                const transfersData = res.data;
                exportMalamPayrollFileFromTransfers(date, transfersData);
            })
            .catch(e => {
                toast({
                    title: `שגיאה בהורדת הדו"ח`,
                    position: 'top',
                    status: 'error',
                    isClosable: false,
                });
            });
    }


    const handleHilanExportClick = () => {
        ReportsApi.getTransfersListWithFee(date, reportCompanyId)
            .then(res => {
                const transfersData = res.data;
                exportHilanPayrollFileFromTransfers(date, transfersData);
            })
            .catch(e => {
                toast({
                    title: `שגיאה בהורדת הדו"ח`,
                    position: 'top',
                    status: 'error',
                    isClosable: false,
                });
            });
    }

    const handleDownloadDetailedReportClick = () => {
        ReportsApi.getTransfersListWithFee(date, reportCompanyId)
            .then(res => {
                const jsonData = res.data;
                exportHomeCenterTransfersFeesFile(jsonData, toast, date, reportCompanyId);
            })
            .catch(e => {
                console.log("error is: ", e);
                console.error('Error fetching data: ', e);
                toast({
                    title: `שגיאה בהורדת המסמך`,
                    position: 'top',
                    status: 'error',
                    isClosable: false,
                });
            });
    };

    const handleDownloadDetailedReport2Click = () => {
        ReportsApi.getTransfersListWithFee(date, reportCompanyId)
            .then(res => {
                const jsonData = res.data;
                exportHalperinTransfersFeesFile(jsonData, toast, date, reportCompanyId);
            })
            .catch(e => {
                console.log("error is: ", e);
                console.error('Error fetching data: ', e);
                toast({
                    title: `שגיאה בהורדת המסמך`,
                    position: 'top',
                    status: 'error',
                    isClosable: false,
                });
            });
    };

    const handleDownloadEmployeeTransfersFeeInvoice = () => {
        ReportsApi.downloadDocumentPdf(DocumentTypesEnum.EMPLOYEE_TRANSFERS_FEE_INVOICE, report.id)
            .then(res => {
            downloadPdf(res, "download.pdf");

            toast({
                position: "top",
                title: 'הורדת המסמך הצליחה',
                status: 'success',
                duration: 5000,
                isClosable: true,
            });

        }).catch(e => {
            toast({

                title: `שגיאה בהורדת המסמך`,

                position: 'top',
                status: 'error',
                isClosable: false,
            })

        })
    }

const handleDownloadEmployeeAdvanceTransferRequest = () => {
    ReportsApi.downloadDocumentPdf(DocumentTypesEnum.EMPLOYEE_ADVANCE_TRANSFER_REQUEST, report.id)
        .then(res => {
            downloadPdf(res, "download.pdf");

            toast({
                position: "top",
                title: 'הורדת המסמך הצליחה',
                status: 'success',
                duration: 5000,
                isClosable: true,
            });

        }).catch(e => {
        toast({
            title: `שגיאה בהורדת הקובץ`,
            position: 'top',
            status: 'error',
            isClosable: false,
        })

    })
}

    const handlePazDetailedReportClick = () => {
        // Use current pay period if tempReport is true and date is empty
        const payPeriod = tempReport && !date ? getCurrentPayPeriod() : date;

        ReportsApi.getPazReports(payPeriod, reportCompanyId)
            .then(res => {
                const jsonData = res.data;
                exportPazDetailedReport(jsonData.detailed, toast);
            })
            .catch(e => {
                console.log("error is: ", e);
                console.error('Error fetching Paz detailed report: ', e);
                toast({
                    title: `שגיאה בהורדת הדו"ח המפורט`,
                    position: 'top',
                    status: 'error',
                    isClosable: false,
                });
            });
    };

    const handlePazSummaryReportClick = () => {
        // Use current pay period if tempReport is true and date is empty
        const payPeriod = tempReport && !date ? getCurrentPayPeriod() : date;

        ReportsApi.getPazReports(payPeriod, reportCompanyId)
            .then(res => {
                const jsonData = res.data;
                exportPazSummaryReport(jsonData.summary, toast);
            })
            .catch(e => {
                console.log("error is: ", e);
                console.error('Error fetching Paz summary report: ', e);
                toast({
                    title: `שגיאה בהורדת הדו"ח המסכם`,
                    position: 'top',
                    status: 'error',
                    isClosable: false,
                });
            });
    };

    // Helper function to get current pay period in MM/YYYY format
    const getCurrentPayPeriod = () => {
        const currentDate = new Date();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = currentDate.getFullYear();
        return `${month}/${year}`;
    };

    return (
        <Modal isOpen={isOpen}
               onClose={onClose}
               isCentered
               closeOnOverlayClick={false}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{tempReport ? 'בדיקת דו״חות פז' : 'סיכום חודשי'}</ModalHeader>
                <ModalBody>

                    {tempReport ? (
                        // Show only Paz reports for temp report
                        <>
                            <Text marginTop='20px' fontSize='16px' textAlign='center'>
                                דו״חות פז לתקופה הנוכחית
                            </Text>
                            <SimpleGrid
                                marginTop='30px'
                                columns={{sm: 2}}
                                gap='10px'
                                mb='0px'>
                                <Button backgroundColor='blue.200' maxW={'150px'} onClick={handlePazDetailedReportClick}>דו״ח מפורט פז</Button>
                                <Button backgroundColor='blue.200' maxW={'150px'} onClick={handlePazSummaryReportClick}>דו״ח מסכם פז</Button>
                            </SimpleGrid>
                        </>
                    ) : (
                        // Show regular report content
                        <>
                            <SimpleGrid
                                marginTop='00px'
                                columns={{sm: 2}}
                                gap='10px'
                                mb='0px'>


                                {reportCompanyId === 117 ? (
                                    <>
                                        <Text marginTop='15px'>סה״כ העברות (כולל עמלות)</Text>
                                        <Text marginTop='15px'>₪{(Number(totalTransfers) || 0) + (Number(totalEmployeesTransferFees) || 0)}</Text>
                                    </>
                                ) : (
                                    <>
                                        <Text marginTop='15px'>סה״כ העברות</Text>
                                        <Text marginTop='15px'>₪{totalTransfers}</Text>

                                        <Text>סה״כ עמלות עובדים (העברות)</Text>
                                        <Text>₪{totalEmployeesTransferFees}</Text>
                                    </>
                                )}

                                { totalCompanyServiceSubscriptionFee > 0 &&
                                    <Text>סה״כ עמלת מעסיק (דמי שימוש)</Text>
                                }

                                { totalCompanyServiceSubscriptionFee > 0 &&
                                    <Text >₪{totalCompanyServiceSubscriptionFee}</Text>
                                }

                                { deductTransferFeesFromSubscription && totalCompanyServiceSubscriptionFee > 0 && (
                                    <Text>עמלת מעסיק לאחר ניכוי</Text>
                                )}
                                { deductTransferFeesFromSubscription && totalCompanyServiceSubscriptionFee > 0 && (
                                    <Text>
                                        ₪{(
                                            Math.max(
                                                0,
                                                totalCompanyServiceSubscriptionFee -
                                                    (totalEmployeesTransferFees || 0) / 1.18
                                            ) * 1.18
                                        ).toFixed(2)}
                                    </Text>
                                )}

                            </SimpleGrid>

                            <SimpleGrid
                                marginTop='30px'
                                columns={{sm: 2}}
                                gap='10px'
                                mb='0px'>

                                <Text fontWeight='bold' fontSize='20px'>סה״כ</Text>
                                <Text fontWeight='bold' fontSize='20px'>₪{totalSettlementAmount}</Text>

                            </SimpleGrid>

                            <Text marginTop='30px' fontSize='18px' fontWeight='bold'>דו״ח ניכויים לתוכנת שכר</Text>

                            <SimpleGrid
                                marginTop='20px'
                                columns={{sm: 3}}
                                gap='10px'
                                mb='0px'>

                                <Button backgroundColor='green.200' maxW={'100px'} onClick={handlePayrollExportClick}>שקלולית</Button>
                                <Button backgroundColor='green.200' maxW={'100px'} onClick={handleMalamExportClick}>מלם</Button>
                                <Button backgroundColor='green.200' maxW={'100px'} onClick={handleHilanExportClick}>חילן</Button>
                                <Button backgroundColor='green.200' maxW={'100px'} onClick={handleDownloadDetailedReportClick}>דו״ח מפורט</Button>
                                <Button backgroundColor='green.200' maxW={'100px'} onClick={handleDownloadDetailedReport2Click}>דו״ח מפורט 2</Button>
                            </SimpleGrid>

                            {/* Paz-specific reports - only show for PAZ company (ID: 39) */}
                            {reportCompanyId == "39" && (
                                <>
                                    <Text marginTop='30px' fontSize='18px' fontWeight='bold'>דו״חות פז</Text>
                                    <SimpleGrid
                                        marginTop='20px'
                                        columns={{sm: 2}}
                                        gap='10px'
                                        mb='0px'>
                                        <Button backgroundColor='blue.200' maxW={'150px'} onClick={handlePazDetailedReportClick}>דו״ח מפורט פז</Button>
                                        <Button backgroundColor='blue.200' maxW={'150px'} onClick={handlePazSummaryReportClick}>דו״ח מסכם פז</Button>
                                    </SimpleGrid>
                                </>
                            )}
                        </>
                    )}

                    <Stack spacing={4} style={{marginTop: "30px"}}>
                        <Button
                            width="auto"
                            whiteSpace="normal"
                            wordWrap="break-word"
                            backgroundColor="green.200"
                            onClick={handleDownloadEmployeeTransfersFeeInvoice}>
                            חשבונית מס - עמלות משיכה עובדים
                        </Button>

                        <Button
                            width="auto"
                            whiteSpace="normal"
                            wordWrap="break-word"
                            backgroundColor="green.200"
                            onClick={handleDownloadEmployeeAdvanceTransferRequest}>
                            דרישת תשלום - העברת מקדמות עובדים
                        </Button>
                    </Stack>


                </ModalBody>
                <ModalFooter>
                    <Button onClick={onClose}>סגור</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
